import React from 'react';
import styled from 'styled-components';
import { map, toLower } from 'lodash';
import { createMessage, getMessagesForRoomRef } from '../firestore/message';
import { CurrentUserContext } from '../contexts/CurrentUserContext';
import { Message, User } from '../types';
import { userGuessedCorrectly } from '../firestore/room';

const Messages =
    styled.div <
    { ref: any } >
    `
    overflow: auto;
`;

const ChatContainer = styled.div`
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

const Input = styled.input`
    width: 100%;
    display: block;
`;
const Button = styled.button`
    display: block;
`;

const Chatter = styled.div`
    opacity: 0.75;
    font-size: 10px;
`;

const AdminMessage = styled.div`
    font-size: 10px;
    color: green;
`;

const Content = styled.div`
    margin-left: 5px;
    font-size: 12px;
`;

// TODO: Handle users here
export const Chat = ({
    roomId,
    users,
    answer,
    allowGuess,
}: {
    roomId: string,
    users: { [id: string]: User },
    answer?: any,
    allowGuess: boolean,
}) => {
    const [messages, setMessages] = React.useState<Message[]>([]);
    const { currentUserId } = React.useContext(CurrentUserContext);
    const [content, setContent] = React.useState('');
    const messagesRef = React.useRef<HTMLDivElement>();

    React.useEffect(() => {
        if (roomId) {
            const handleChildAdded = (dataSnapshot: firebase.database.DataSnapshot) => {
                const newMessage = dataSnapshot.val();
                setMessages((messages) => [newMessage, ...messages]);
            };
            getMessagesForRoomRef(roomId).limitToLast(20).on('child_added', handleChildAdded);
            return () => getMessagesForRoomRef(roomId).off('child_added', handleChildAdded);
        }
    }, [roomId]);

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (content) {
            if (toLower(content) === toLower(answer) && allowGuess) {
                userGuessedCorrectly(roomId, currentUserId);
            } else {
                createMessage(currentUserId, roomId, content);
            }
            setContent('');
            if (messagesRef.current) {
                messagesRef.current.scrollTop = 0;
            }
        }
    };

    return (
        <ChatContainer>
            <form onSubmit={handleSubmit}>
                <Input
                    autoCorrect="off"
                    autoCapitalize="none"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                />
                <Button onClick={handleSubmit}>Send</Button>
            </form>
            <Messages ref={messagesRef}>
                {map(messages, ({ userId, content, id }) => {
                    if (userId === 'admin') {
                        return <AdminMessage key={id}>[{content}]</AdminMessage>;
                    }
                    return (
                        <div key={id}>
                            <Chatter>{users[userId]?.name}:</Chatter>
                            <Content>{content}</Content>
                        </div>
                    );
                })}
            </Messages>
        </ChatContainer>
    );
};
